import { render } from "./DialogLoader.vue?vue&type=template&id=151f87dd&scoped=true"
import script from "./DialogLoader.vue?vue&type=script&lang=js"
export * from "./DialogLoader.vue?vue&type=script&lang=js"

import "./DialogLoader.vue?vue&type=style&index=0&id=151f87dd&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151f87dd"]])

export default __exports__